<div class="main row">
  <ds-confirmation [confirmationData]="this.confirmationData$ | async">
    <ds-confirmation-link-area>
      <div class="flex items-center link-button">
        <span class="back-icon icon-chevron-left"> </span>
        <a class="font-weight-semibold" href="javascript:void(0);" (click)="backToOverview()"
          >Back To Overview</a
        >
      </div>
    </ds-confirmation-link-area>
  </ds-confirmation>
</div>
